import { isString } from 'lodash';
import * as React from 'react';
import { ReactNode } from 'react';
import { Href } from 'redux-little-router';

import { Bem } from '../../../service/Bem/Bem';
import { LinkTarget, NavLinkData, ThemePopup } from '../../../typings/common';
import { PopupDecorator } from '../../PopupDecorator/PopupDecorator';
import { Shape2, Shape2Theme } from '../../Shape2/Shape2';
import {
    RouteStyledLink,
    StyledLink,
    StyledLinkTheme
} from '../../StyledLink/StyledLink';
import { TabMenuSize, TabMenuTheme } from '../TabMenu';

import './TabGroupMenu.css';

interface TabGroupMenuProps {
    items: Array<NavLinkData>;
    theme: TabMenuTheme;
    size: TabMenuSize;
    title: React.ReactNode | React.ReactNode[];
}

interface TabGroupMenuState {
    isPopupVisible: boolean;
}

export class TabGroupMenu extends React.Component<
    TabGroupMenuProps,
    TabGroupMenuState
> {
    constructor(props: TabGroupMenuProps) {
        super(props);

        this.state = {
            isPopupVisible: false
        };
    }

    render() {
        const { theme, title } = this.props;
        const { isPopupVisible } = this.state;

        return (
            <>
                <span
                    className={Bem.cls({
                        block: 'tab-group-menu',
                        mods: {
                            size: 'm',
                            theme,
                            active: isPopupVisible
                        }
                    })}
                    onClick={this.switchPopupState}
                >
                    {title}
                </span>
                {this.getDropdownMenu()}
            </>
        );
    }

    getDropdownMenu = () => {
        return (
            <PopupDecorator
                visible={this.state.isPopupVisible}
                target={'anchor'}
                anchor={this}
                directions={['bottom-center']}
                onOutsideClick={this.close}
                theme={ThemePopup.CLEAR}
                hasTail={true}
            >
                <div className={Bem.cls('tab-group-menu', 'items-content')}>
                    {this.getListItems()}
                </div>
            </PopupDecorator>
        );
    };

    switchPopupState = () => {
        this.setState({ isPopupVisible: !this.state.isPopupVisible });
    };

    close = () => {
        this.setState({ isPopupVisible: false });
    };

    private getListItems = () => {
        const { items } = this.props;

        return items.map(
            (
                {
                    title,
                    description,
                    icon,
                    location,
                    isExternal,
                    target,
                    onClick
                },
                key
            ) => {
                const item = (
                    <div className={Bem.cls('tab-group-menu', 'item-content')}>
                        {icon !== undefined ? (
                            <Shape2
                                cls={Bem.cls('campaign-types-list', 'icon')}
                                theme={Shape2Theme.light}
                                icon={icon}
                                width={16}
                                height={16}
                            />
                        ) : null}
                        <div>
                            <div
                                className={Bem.cls(
                                    'tab-group-menu',
                                    'item-title'
                                )}
                            >
                                {title}
                            </div>
                            <div
                                className={Bem.cls(
                                    'tab-group-menu',
                                    'item-description'
                                )}
                            >
                                {description}
                            </div>
                        </div>
                    </div>
                );

                return this.getLink(
                    item,
                    key,
                    isExternal,
                    location,
                    target,
                    onClick
                );
            }
        );
    };

    private getLink = (
        component: ReactNode,
        key: number,
        isExternal?: boolean,
        href?: Href,
        target?: LinkTarget,
        onClick?: () => void
    ) => {
        if (isExternal && isString(href)) {
            return (
                <StyledLink
                    key={key}
                    target={target}
                    theme={StyledLinkTheme.black}
                    href={href}
                    onClick={onClick}
                >
                    {component}
                </StyledLink>
            );
        } else if (href) {
            return (
                <RouteStyledLink
                    key={key}
                    theme={StyledLinkTheme.black}
                    href={href}
                    onClick={onClick}
                >
                    {component}
                </RouteStyledLink>
            );
        }

        return null;
    };
}
